import React from 'react'
import Icon from 'react-icon-base'

export default props => {
  return (
    <Icon viewBox="0 0 18 18" {...props}>
      <title id="Unmute">{props.title || 'Unmute'}</title>
      <g>
        <path
          d="M11 0v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77C18 4.49 15.01.91 11 0zm2.5 8.77c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM0 5.77v6h4l5 5v-16l-5 5H0z"
          fillRule="evenodd"
        />
      </g>
    </Icon>
  )
}



// WEBPACK FOOTER //
// ./client/components/icons/unmute.js